module.exports = __webpack_public_path__ + "img/angle-double-right.d88d2ba7.svg";